import reducer, { addRoutes } from 'location-info'

// Define our inital state object. This could be a fetch() to an API endpoint.

export const routes = {
  filmfest: '/details/recPkxpU5hm2lfIWC',
  details: '/details/:showId',
  home: '/',
  me: '/me(/:artId)',
  studentList: '/students',
  studentDetail: '/students/:studentId',
  splash: '/splash',
  splashAlt: '/alt',
}
export const locInfo = reducer(undefined, addRoutes(routes))

export default {
  db: {},
  firebase: {
    config: {
      apiKey: 'AIzaSyB6Nr6Bj27_-Llc6-vZH8dM4vzKSDO4L6A',
      authDomain: 'mgs-2019.firebaseapp.com',
      databaseURL: 'https://mgs-2019.firebaseio.com',
      projectId: 'mgs-2019',
      storageBucket: 'mgs-2019.appspot.com',
      messagingSenderId: '978868258615',
    },
    entityType: {
      CreativeWork: true,
      ImageObject: true,
      MediaObject: true,
      ShowGroup: true,
      Show: true,
      SplashArt: true,
      Program: true,
      Location: true,
      Person: true,
      Student: true,
    },
  },
  locInfo,
}
